// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   CircularProgress,
//   Alert,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip,
//   Button,
//   Divider,
//   Tabs,
//   Tab,
//   Avatar,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemAvatar,
//   IconButton,
//   Tooltip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import {
//   DirectionsCar,
//   People,
//   LocalTaxi,
//   AttachMoney,
//   TrendingUp,
//   TrendingDown,
//   Pending,
//   Payment,
//   Receipt,
//   Download,
//   FilterList,
//   Search,
//   Refresh,
//   Visibility,
//   CheckCircle,
//   Cancel,
//   PendingActions,
// } from '@mui/icons-material';
// import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from 'recharts';
// import apiService from '../services/apiService';
// import socketService from '../services/socketService';

// // Dummy Razorpay payment data
// const dummyRazorpayPayments = [
//   {
//     id: 'pay_1X2Y3Z4A5B6C7D',
//     orderId: 'order_ABC123DEF456',
//     amount: 450,
//     currency: 'INR',
//     status: 'captured',
//     method: 'card',
//     email: 'john.doe@example.com',
//     contact: '+919876543210',
//     description: 'Ride #R12345 - Sedan',
//     createdAt: '2026-07-08T10:30:00Z',
//     driverName: 'Rajesh Kumar',
//     driverId: 'DRV001',
//     passengerName: 'John Doe',
//     passengerId: 'PASS001',
//     rideId: 'R12345',
//     vehicleType: 'Sedan',
//     paymentMethod: 'Credit Card',
//     cardDetails: 'Visa ending 4242',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_2X3Y4Z5A6B7C8D',
//     orderId: 'order_GHI789JKL012',
//     amount: 280,
//     currency: 'INR',
//     status: 'captured',
//     method: 'upi',
//     email: 'priya.sharma@example.com',
//     contact: '+919887654321',
//     description: 'Ride #R12346 - Auto',
//     createdAt: '2026-07-08T09:15:00Z',
//     driverName: 'Suresh Reddy',
//     driverId: 'DRV002',
//     passengerName: 'Priya Sharma',
//     passengerId: 'PASS002',
//     rideId: 'R12346',
//     vehicleType: 'Auto',
//     paymentMethod: 'UPI',
//     cardDetails: 'UPI: priya@paytm',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_3Y4Z5A6B7C8D9E',
//     orderId: 'order_MNO345PQR678',
//     amount: 350,
//     currency: 'INR',
//     status: 'captured',
//     method: 'card',
//     email: 'amit.patel@example.com',
//     contact: '+919998887777',
//     description: 'Ride #R12347 - Mini',
//     createdAt: '2026-07-07T22:45:00Z',
//     driverName: 'Vikram Singh',
//     driverId: 'DRV003',
//     passengerName: 'Amit Patel',
//     passengerId: 'PASS003',
//     rideId: 'R12347',
//     vehicleType: 'Mini',
//     paymentMethod: 'Debit Card',
//     cardDetails: 'Mastercard ending 5555',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_4Z5A6B7C8D9E0F',
//     orderId: 'order_STU901VWX234',
//     amount: 520,
//     currency: 'INR',
//     status: 'captured',
//     method: 'card',
//     email: 'sneha.menon@example.com',
//     contact: '+919665544332',
//     description: 'Ride #R12348 - SUV',
//     createdAt: '2026-07-07T18:20:00Z',
//     driverName: 'Manoj Nair',
//     driverId: 'DRV004',
//     passengerName: 'Sneha Menon',
//     passengerId: 'PASS004',
//     rideId: 'R12348',
//     vehicleType: 'SUV',
//     paymentMethod: 'Credit Card',
//     cardDetails: 'Visa ending 9876',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_5A6B7C8D9E0F1G',
//     orderId: 'order_YZA567BCD890',
//     amount: 190,
//     currency: 'INR',
//     status: 'captured',
//     method: 'upi',
//     email: 'rahul.kumar@example.com',
//     contact: '+919887766554',
//     description: 'Ride #R12349 - Bike',
//     createdAt: '2026-07-07T14:00:00Z',
//     driverName: 'Ravi Teja',
//     driverId: 'DRV005',
//     passengerName: 'Rahul Kumar',
//     passengerId: 'PASS005',
//     rideId: 'R12349',
//     vehicleType: 'Bike',
//     paymentMethod: 'Google Pay',
//     cardDetails: 'UPI: rahul@gpay',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_6B7C8D9E0F1G2H',
//     orderId: 'order_EFG345HIJ678',
//     amount: 410,
//     currency: 'INR',
//     status: 'captured',
//     method: 'card',
//     email: 'neha.gupta@example.com',
//     contact: '+919998887766',
//     description: 'Ride #R12350 - Sedan',
//     createdAt: '2026-07-06T20:10:00Z',
//     driverName: 'Arjun Rao',
//     driverId: 'DRV006',
//     passengerName: 'Neha Gupta',
//     passengerId: 'PASS006',
//     rideId: 'R12350',
//     vehicleType: 'Sedan',
//     paymentMethod: 'Credit Card',
//     cardDetails: 'Visa ending 3333',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_7C8D9E0F1G2H3I',
//     orderId: 'order_JKL901MNO234',
//     amount: 300,
//     currency: 'INR',
//     status: 'captured',
//     method: 'card',
//     email: 'vijay.malhotra@example.com',
//     contact: '+919887754433',
//     description: 'Ride #R12351 - Auto',
//     createdAt: '2026-07-06T16:45:00Z',
//     driverName: 'Prakash Raj',
//     driverId: 'DRV007',
//     passengerName: 'Vijay Malhotra',
//     passengerId: 'PASS007',
//     rideId: 'R12351',
//     vehicleType: 'Auto',
//     paymentMethod: 'Debit Card',
//     cardDetails: 'Mastercard ending 7777',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_8D9E0F1G2H3I4J',
//     orderId: 'order_PQR567STU890',
//     amount: 480,
//     currency: 'INR',
//     status: 'captured',
//     method: 'card',
//     email: 'anita.deshpande@example.com',
//     contact: '+919665544321',
//     description: 'Ride #R12352 - Mini',
//     createdAt: '2026-07-06T12:30:00Z',
//     driverName: 'Kiran Kumar',
//     driverId: 'DRV008',
//     passengerName: 'Anita Deshpande',
//     passengerId: 'PASS008',
//     rideId: 'R12352',
//     vehicleType: 'Mini',
//     paymentMethod: 'Credit Card',
//     cardDetails: 'Amex ending 4444',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_9E0F1G2H3I4J5K',
//     orderId: 'order_VWX234YZA567',
//     amount: 560,
//     currency: 'INR',
//     status: 'captured',
//     method: 'card',
//     email: 'deepak.chopra@example.com',
//     contact: '+919998776655',
//     description: 'Ride #R12353 - SUV',
//     createdAt: '2026-07-05T09:00:00Z',
//     driverName: 'Ganesh Iyer',
//     driverId: 'DRV009',
//     passengerName: 'Deepak Chopra',
//     passengerId: 'PASS009',
//     rideId: 'R12353',
//     vehicleType: 'SUV',
//     paymentMethod: 'Credit Card',
//     cardDetails: 'Visa ending 1111',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_0F1G2H3I4J5K6L',
//     orderId: 'order_BCD890EFG123',
//     amount: 230,
//     currency: 'INR',
//     status: 'captured',
//     method: 'upi',
//     email: 'sunil.sheth@example.com',
//     contact: '+919887665544',
//     description: 'Ride #R12354 - Bike',
//     createdAt: '2026-07-05T07:30:00Z',
//     driverName: 'Ramesh Reddy',
//     driverId: 'DRV010',
//     passengerName: 'Sunil Sheth',
//     passengerId: 'PASS010',
//     rideId: 'R12354',
//     vehicleType: 'Bike',
//     paymentMethod: 'PhonePe',
//     cardDetails: 'UPI: sunil@phonepe',
//     refundStatus: null,
//   },
// ];

// // Pending payments for admin approval
// const dummyPendingPayments = [
//   {
//     id: 'pay_11G2H3I4J5K6L7M',
//     orderId: 'order_HIJ456KLM789',
//     amount: 390,
//     currency: 'INR',
//     status: 'pending',
//     method: 'card',
//     email: 'mohammed.ali@example.com',
//     contact: '+919665543210',
//     description: 'Ride #R12355 - Sedan',
//     createdAt: '2026-07-08T11:00:00Z',
//     driverName: 'Imran Khan',
//     driverId: 'DRV011',
//     passengerName: 'Mohammed Ali',
//     passengerId: 'PASS011',
//     vehicleType: 'Sedan',
//     paymentMethod: 'Credit Card',
//     cardDetails: 'Visa ending 8888',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_12H3I4J5K6L7M8N',
//     orderId: 'order_NOP234QRS567',
//     amount: 310,
//     currency: 'INR',
//     status: 'pending',
//     method: 'upi',
//     email: 'kavita.verma@example.com',
//     contact: '+919998887755',
//     description: 'Ride #R12356 - Auto',
//     createdAt: '2026-07-08T08:20:00Z',
//     driverName: 'Sanjay Kumar',
//     driverId: 'DRV012',
//     passengerName: 'Kavita Verma',
//     passengerId: 'PASS012',
//     rideId: 'R12356',
//     vehicleType: 'Auto',
//     paymentMethod: 'Paytm',
//     cardDetails: 'UPI: kavita@paytm',
//     refundStatus: null,
//   },
//   {
//     id: 'pay_13I4J5K6L7M8N9O',
//     orderId: 'order_TUV678WXY901',
//     amount: 440,
//     currency: 'INR',
//     status: 'pending',
//     method: 'card',
//     email: 'rajesh.khanna@example.com',
//     contact: '+919887443322',
//     description: 'Ride #R12357 - Mini',
//     createdAt: '2026-07-07T23:00:00Z',
//     driverName: 'Ashok Singh',
//     driverId: 'DRV013',
//     passengerName: 'Rajesh Khanna',
//     passengerId: 'PASS013',
//     rideId: 'R12357',
//     vehicleType: 'Mini',
//     paymentMethod: 'Debit Card',
//     cardDetails: 'Mastercard ending 2222',
//     refundStatus: null,
//   },
// ];

// const StatCard = ({ title, value, icon, color, trend, trendValue }) => (
//   <Card>
//     <CardContent>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//         <Box>
//           <Typography variant="body2" color="text.secondary" gutterBottom>
//             {title}
//           </Typography>
//           <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
//             {value}
//           </Typography>
//           {trend && (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//               {trend === 'up' ? (
//                 <TrendingUp sx={{ fontSize: 18, color: 'success.main' }} />
//               ) : (
//                 <TrendingDown sx={{ fontSize: 18, color: 'error.main' }} />
//               )}
//               <Typography
//                 variant="caption"
//                 color={trend === 'up' ? 'success.main' : 'error.main'}
//               >
//                 {trendValue}
//               </Typography>
//             </Box>
//           )}
//         </Box>
//         <Box
//           sx={{
//             bgcolor: color + '20',
//             p: 1.5,
//             borderRadius: 2,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           {React.cloneElement(icon, { sx: { fontSize: 32, color } })}
//         </Box>
//       </Box>
//     </CardContent>
//   </Card>
// );

// const EarningDashboardPage = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [stats, setStats] = useState({
//     totalDrivers: 15,
//     onlineDrivers: 8,
//     totalPassengers: 120,
//     totalRides: 1250,
//     activeRides: 12,
//     revenueToday: 24580,
//     revenueMonth: 425600,
//     pendingVerifications: 3,
//     pendingWithdrawals: 5,
//     totalEarnings: 1250000,
//     todayEarnings: 24580,
//     weekEarnings: 156780,
//     monthEarnings: 425600,
//     averageOrderValue: 385,
//   });
//   const [ridesData, setRidesData] = useState([]);
//   const [revenueData, setRevenueData] = useState([]);
//   const [vehicleTypeData, setVehicleTypeData] = useState([]);
//   const [payments, setPayments] = useState(dummyRazorpayPayments);
//   const [pendingPayments, setPendingPayments] = useState(dummyPendingPayments);
//   const [selectedPayment, setSelectedPayment] = useState(null);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [tabValue, setTabValue] = useState(0);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [filterPaymentMethod, setFilterPaymentMethod] = useState('all');

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         setLoading(true);
//         setError('');

//         // Generate dummy chart data
//         generateDummyChartData();

//         // Update stats with dummy data
//         const totalPaymentAmount = dummyRazorpayPayments.reduce((sum, p) => sum + p.amount, 0);
//         const todayPayments = dummyRazorpayPayments.filter(p => 
//           new Date(p.createdAt).toDateString() === new Date().toDateString()
//         );
//         const todayAmount = todayPayments.reduce((sum, p) => sum + p.amount, 0);

//         setStats(prev => ({
//           ...prev,
//           totalEarnings: totalPaymentAmount,
//           todayEarnings: todayAmount,
//           weekEarnings: Math.round(totalPaymentAmount * 0.7),
//           monthEarnings: Math.round(totalPaymentAmount * 1.5),
//           averageOrderValue: Math.round(totalPaymentAmount / dummyRazorpayPayments.length),
//           totalRides: dummyRazorpayPayments.length + dummyPendingPayments.length,
//           activeRides: 8,
//         }));

//       } catch (err) {
//         console.error('Dashboard error:', err);
//         setError('Failed to load dashboard data.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     const generateDummyChartData = () => {
//       // Generate rides data for last 7 days
//       const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
//       const rideData = days.map((day, index) => ({
//         day,
//         rides: Math.floor(Math.random() * 30) + 10,
//         completed: Math.floor(Math.random() * 20) + 15,
//         amount: Math.floor(Math.random() * 15000) + 5000,
//       }));
//       setRidesData(rideData);

//       // Generate revenue data for last 6 months
//       const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
//       const revenueData = months.map((month, index) => ({
//         month,
//         revenue: Math.floor(Math.random() * 200000) + 50000,
//         rides: Math.floor(Math.random() * 50) + 20,
//       }));
//       setRevenueData(revenueData);

//       // Generate vehicle type distribution
//       const vehicleTypes = [
//         { name: 'Auto', value: 35, color: '#FFC107' },
//         { name: 'Bike', value: 20, color: '#FF9800' },
//         { name: 'Mini', value: 25, color: '#FF5722' },
//         { name: 'Sedan', value: 15, color: '#F44336' },
//         { name: 'SUV', value: 5, color: '#E91E63' },
//       ];
//       setVehicleTypeData(vehicleTypes);
//     };

//     // Socket listener for real-time updates
//     socketService.onDashboardUpdate((data) => {
//       setStats((prev) => ({
//         ...prev,
//         ...data,
//       }));
//     });

//     loadData();

//     // Refresh data every 30 seconds
//     const refreshInterval = setInterval(loadData, 30000);

//     return () => {
//       clearInterval(refreshInterval);
//       socketService.off('admin:dashboard-update');
//     };
//   }, []);

//   const handlePaymentClick = (payment) => {
//     setSelectedPayment(payment);
//     setDialogOpen(true);
//   };

//   const handleCloseDialog = () => {
//     setDialogOpen(false);
//     setSelectedPayment(null);
//   };

//   const handleApprovePayment = (paymentId) => {
//     setPendingPayments(prev => prev.filter(p => p.id !== paymentId));
//     const approvedPayment = pendingPayments.find(p => p.id === paymentId);
//     if (approvedPayment) {
//       setPayments(prev => [...prev, { ...approvedPayment, status: 'captured' }]);
//       // Update stats
//       setStats(prev => ({
//         ...prev,
//         totalEarnings: prev.totalEarnings + approvedPayment.amount,
//         totalRides: prev.totalRides + 1,
//       }));
//     }
//   };

//   const handleRejectPayment = (paymentId) => {
//     setPendingPayments(prev => prev.filter(p => p.id !== paymentId));
//   };

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   const getStatusChip = (status) => {
//     switch (status) {
//       case 'captured':
//         return <Chip icon={<CheckCircle />} label="Completed" color="success" size="small" />;
//       case 'pending':
//         return <Chip icon={<PendingActions />} label="Pending" color="warning" size="small" />;
//       case 'refunded':
//         return <Chip icon={<Cancel />} label="Refunded" color="error" size="small" />;
//       default:
//         return <Chip label={status} size="small" />;
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   const getFilteredPayments = () => {
//     let filtered = payments;
    
//     if (searchTerm) {
//       filtered = filtered.filter(p => 
//         p.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.passengerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.driverName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.rideId?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     if (filterStatus !== 'all') {
//       filtered = filtered.filter(p => p.status === filterStatus);
//     }
    
//     if (filterPaymentMethod !== 'all') {
//       filtered = filtered.filter(p => p.method === filterPaymentMethod);
//     }
    
//     return filtered;
//   };

//   const getFilteredPendingPayments = () => {
//     let filtered = pendingPayments;
    
//     if (searchTerm) {
//       filtered = filtered.filter(p => 
//         p.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.passengerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.driverName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.rideId?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     return filtered;
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
//         <CircularProgress sx={{ color: 'primary.main' }} />
//       </Box>
//     );
//   }

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Box>
//           <Typography variant="h4" fontWeight="bold" gutterBottom>
//             Earnings Dashboard
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Real-time overview of your taxi booking platform earnings
//           </Typography>
//         </Box>
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Button variant="outlined" startIcon={<Refresh />} onClick={() => window.location.reload()}>
//             Refresh
//           </Button>
//           <Button variant="contained" startIcon={<Download />}>
//             Export Report
//           </Button>
//         </Box>
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       {/* Stats Cards */}
//       <Grid container spacing={3} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="Total Earnings"
//             value={formatCurrency(stats.totalEarnings)}
//             icon={<AttachMoney />}
//             color="#4CAF50"
//             trend="up"
//             trendValue="12.5%"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="Today's Earnings"
//             value={formatCurrency(stats.todayEarnings)}
//             icon={<Payment />}
//             color="#FFC107"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="This Week"
//             value={formatCurrency(stats.weekEarnings)}
//             icon={<TrendingUp />}
//             color="#2196F3"
//             trend="up"
//             trendValue="8.3%"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="This Month"
//             value={formatCurrency(stats.monthEarnings)}
//             icon={<TrendingUp />}
//             color="#9C27B0"
//             trend="up"
//             trendValue="15.7%"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="Total Rides"
//             value={stats.totalRides}
//             icon={<LocalTaxi />}
//             color="#FF9800"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="Average Order Value"
//             value={formatCurrency(stats.averageOrderValue)}
//             icon={<Receipt />}
//             color="#00BCD4"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="Pending Payments"
//             value={pendingPayments.length}
//             icon={<Pending />}
//             color="#F44336"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <StatCard
//             title="Total Drivers"
//             value={stats.totalDrivers}
//             icon={<DirectionsCar />}
//             color="#FF5722"
//           />
//         </Grid>
//       </Grid>

//       {/* Charts */}
//       <Grid container spacing={3} sx={{ mb: 3 }}>
//         {/* Rides Chart */}
//         <Grid item xs={12} lg={8}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" fontWeight="bold" gutterBottom>
//                 Rides & Earnings Overview (Last 7 Days)
//               </Typography>
//               {ridesData.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={300}>
//                   <LineChart data={ridesData}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="day" />
//                     <YAxis yAxisId="left" />
//                     <YAxis yAxisId="right" orientation="right" />
//                     <RechartsTooltip />
//                     <Legend />
//                     <Line
//                       yAxisId="left"
//                       type="monotone"
//                       dataKey="rides"
//                       stroke="#FFC107"
//                       strokeWidth={2}
//                       name="Total Rides"
//                     />
//                     <Line
//                       yAxisId="left"
//                       type="monotone"
//                       dataKey="completed"
//                       stroke="#4CAF50"
//                       strokeWidth={2}
//                       name="Completed"
//                     />
//                     <Line
//                       yAxisId="right"
//                       type="monotone"
//                       dataKey="amount"
//                       stroke="#2196F3"
//                       strokeWidth={2}
//                       name="Earnings (₹)"
//                     />
//                   </LineChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
//                   <Typography color="text.secondary">No ride data available</Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Vehicle Type Distribution */}
//         <Grid item xs={12} lg={4}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" fontWeight="bold" gutterBottom>
//                 Vehicle Type Distribution
//               </Typography>
//               {vehicleTypeData.some(v => v.value > 0) ? (
//                 <ResponsiveContainer width="100%" height={300}>
//                   <PieChart>
//                     <Pie
//                       data={vehicleTypeData}
//                       cx="50%"
//                       cy="50%"
//                       labelLine={false}
//                       label={(entry) => `${entry.name}: ${entry.value}%`}
//                       outerRadius={80}
//                       fill="#8884d8"
//                       dataKey="value"
//                     >
//                       {vehicleTypeData.map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill={entry.color} />
//                       ))}
//                     </Pie>
//                     <RechartsTooltip />
//                   </PieChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
//                   <Typography color="text.secondary">No vehicle data available</Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Revenue Chart */}
//         <Grid item xs={12}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" fontWeight="bold" gutterBottom>
//                 Revenue & Rides Overview (Last 6 Months)
//               </Typography>
//               {revenueData.some(r => r.revenue > 0) ? (
//                 <ResponsiveContainer width="100%" height={300}>
//                   <BarChart data={revenueData}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="month" />
//                     <YAxis yAxisId="left" />
//                     <YAxis yAxisId="right" orientation="right" />
//                     <RechartsTooltip />
//                     <Legend />
//                     <Bar yAxisId="left" dataKey="revenue" fill="#FFC107" name="Revenue (₹)" />
//                     <Bar yAxisId="right" dataKey="rides" fill="#4CAF50" name="Total Rides" />
//                   </BarChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
//                   <Typography color="text.secondary">No revenue data available</Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Payment Transactions */}
//       <Card>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//             <Typography variant="h6" fontWeight="bold">
//               Payment Transactions
//             </Typography>
//             <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//               <TextField
//                 size="small"
//                 placeholder="Search payments..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 InputProps={{
//                   startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />,
//                 }}
//               />
//               <FormControl size="small" sx={{ minWidth: 120 }}>
//                 <InputLabel>Status</InputLabel>
//                 <Select
//                   value={filterStatus}
//                   onChange={(e) => setFilterStatus(e.target.value)}
//                   label="Status"
//                 >
//                   <MenuItem value="all">All</MenuItem>
//                   <MenuItem value="captured">Completed</MenuItem>
//                   <MenuItem value="pending">Pending</MenuItem>
//                   <MenuItem value="refunded">Refunded</MenuItem>
//                 </Select>
//               </FormControl>
//               <FormControl size="small" sx={{ minWidth: 120 }}>
//                 <InputLabel>Method</InputLabel>
//                 <Select
//                   value={filterPaymentMethod}
//                   onChange={(e) => setFilterPaymentMethod(e.target.value)}
//                   label="Method"
//                 >
//                   <MenuItem value="all">All</MenuItem>
//                   <MenuItem value="card">Card</MenuItem>
//                   <MenuItem value="upi">UPI</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>
//           </Box>

//           <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 2 }}>
//             <Tab label={`All Payments (${getFilteredPayments().length})`} />
//             <Tab label={`Pending (${getFilteredPendingPayments().length})`} />
//           </Tabs>

//           <TableContainer component={Paper} variant="outlined">
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Payment ID</TableCell>
//                   <TableCell>Date & Time</TableCell>
//                   <TableCell>Passenger</TableCell>
//                   <TableCell>Driver</TableCell>
//                   <TableCell>Ride ID</TableCell>
//                   <TableCell>Vehicle</TableCell>
//                   <TableCell>Amount</TableCell>
//                   <TableCell>Method</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {tabValue === 0 ? (
//                   getFilteredPayments().map((payment) => (
//                     <TableRow key={payment.id} hover>
//                       <TableCell>
//                         <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }}>
//                           {payment.id.slice(0, 12)}...
//                         </Typography>
//                       </TableCell>
//                       <TableCell>{formatDate(payment.createdAt)}</TableCell>
//                       <TableCell>{payment.passengerName}</TableCell>
//                       <TableCell>{payment.driverName}</TableCell>
//                       <TableCell>{payment.rideId || '—'}</TableCell>
//                       <TableCell>
//                         <Chip label={payment.vehicleType} size="small" variant="outlined" />
//                       </TableCell>
//                       <TableCell>
//                         <Typography fontWeight="bold" color="success.main">
//                           {formatCurrency(payment.amount)}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Chip 
//                           label={payment.method.toUpperCase()} 
//                           size="small" 
//                           color={payment.method === 'card' ? 'primary' : 'secondary'}
//                         />
//                       </TableCell>
//                       <TableCell>{getStatusChip(payment.status)}</TableCell>
//                       <TableCell>
//                         <Tooltip title="View Details">
//                           <IconButton size="small" onClick={() => handlePaymentClick(payment)}>
//                             <Visibility />
//                           </IconButton>
//                         </Tooltip>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   getFilteredPendingPayments().map((payment) => (
//                     <TableRow key={payment.id} hover sx={{ bgcolor: 'warning.light' }}>
//                       <TableCell>
//                         <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }}>
//                           {payment.id.slice(0, 12)}...
//                         </Typography>
//                       </TableCell>
//                       <TableCell>{formatDate(payment.createdAt)}</TableCell>
//                       <TableCell>{payment.passengerName}</TableCell>
//                       <TableCell>{payment.driverName}</TableCell>
//                       <TableCell>{payment.rideId || '—'}</TableCell>
//                       <TableCell>
//                         <Chip label={payment.vehicleType} size="small" variant="outlined" />
//                       </TableCell>
//                       <TableCell>
//                         <Typography fontWeight="bold" color="warning.main">
//                           {formatCurrency(payment.amount)}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Chip 
//                           label={payment.method.toUpperCase()} 
//                           size="small" 
//                           color={payment.method === 'card' ? 'primary' : 'secondary'}
//                         />
//                       </TableCell>
//                       <TableCell>{getStatusChip('pending')}</TableCell>
//                       <TableCell>
//                         <Box sx={{ display: 'flex', gap: 0.5 }}>
//                           <Tooltip title="Approve Payment">
//                             <IconButton 
//                               size="small" 
//                               color="success"
//                               onClick={() => handleApprovePayment(payment.id)}
//                             >
//                               <CheckCircle />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Reject Payment">
//                             <IconButton 
//                               size="small" 
//                               color="error"
//                               onClick={() => handleRejectPayment(payment.id)}
//                             >
//                               <Cancel />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="View Details">
//                             <IconButton size="small" onClick={() => handlePaymentClick(payment)}>
//                               <Visibility />
//                             </IconButton>
//                           </Tooltip>
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>

//       {/* Payment Details Dialog */}
//       <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
//         {selectedPayment && (
//           <>
//             <DialogTitle>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Typography variant="h6">Payment Details</Typography>
//                 {getStatusChip(selectedPayment.status)}
//               </Box>
//             </DialogTitle>
//             <Divider />
//             <DialogContent>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Payment ID</Typography>
//                   <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>{selectedPayment.id}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Order ID</Typography>
//                   <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>{selectedPayment.orderId}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Amount</Typography>
//                   <Typography variant="h5" color="success.main" fontWeight="bold">
//                     {formatCurrency(selectedPayment.amount)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Payment Method</Typography>
//                   <Typography variant="body1">{selectedPayment.paymentMethod}</Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     {selectedPayment.cardDetails}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Date & Time</Typography>
//                   <Typography variant="body1">{formatDate(selectedPayment.createdAt)}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Status</Typography>
//                   <Typography variant="body1">{selectedPayment.status}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Divider sx={{ my: 1 }} />
//                   <Typography variant="subtitle1" fontWeight="bold">Ride Details</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="text.secondary">Ride ID</Typography>
//                   <Typography variant="body1">{selectedPayment.rideId || '—'}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="text.secondary">Vehicle Type</Typography>
//                   <Typography variant="body1">{selectedPayment.vehicleType}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="text.secondary">Description</Typography>
//                   <Typography variant="body1">{selectedPayment.description}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle1" fontWeight="bold">Customer Details</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="text.secondary">Passenger</Typography>
//                   <Typography variant="body1">{selectedPayment.passengerName}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="text.secondary">Email</Typography>
//                   <Typography variant="body1">{selectedPayment.email}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="text.secondary">Contact</Typography>
//                   <Typography variant="body1">{selectedPayment.contact}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle1" fontWeight="bold">Driver Details</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Driver Name</Typography>
//                   <Typography variant="body1">{selectedPayment.driverName}</Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary">Driver ID</Typography>
//                   <Typography variant="body1">{selectedPayment.driverId}</Typography>
//                 </Grid>
//               </Grid>
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleCloseDialog}>Close</Button>
//               {selectedPayment.status === 'pending' && (
//                 <>
//                   <Button 
//                     variant="contained" 
//                     color="success"
//                     onClick={() => {
//                       handleApprovePayment(selectedPayment.id);
//                       handleCloseDialog();
//                     }}
//                   >
//                     Approve Payment
//                   </Button>
//                   <Button 
//                     variant="contained" 
//                     color="error"
//                     onClick={() => {
//                       handleRejectPayment(selectedPayment.id);
//                       handleCloseDialog();
//                     }}
//                   >
//                     Reject Payment
//                   </Button>
//                 </>
//               )}
//             </DialogActions>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );
// };

// export default EarningDashboardPage;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Divider,
  Tabs,
  Tab,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import {
  DirectionsCar,
  People,
  LocalTaxi,
  AttachMoney,
  TrendingUp,
  TrendingDown,
  Pending,
  Payment,
  Receipt,
  Download,
  FilterList,
  Search,
  Refresh,
  Visibility,
  CheckCircle,
  Cancel,
  PendingActions,
} from '@mui/icons-material';
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from 'recharts';
import apiService from '../services/apiService';
import socketService from '../services/socketService';

const StatCard = ({ title, value, icon, color, trend, trendValue }) => (
  <Card>
    <CardContent>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
            {value}
          </Typography>
          {trend && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {trend === 'up' ? (
                <TrendingUp sx={{ fontSize: 18, color: 'success.main' }} />
              ) : (
                <TrendingDown sx={{ fontSize: 18, color: 'error.main' }} />
              )}
              <Typography
                variant="caption"
                color={trend === 'up' ? 'success.main' : 'error.main'}
              >
                {trendValue}
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            bgcolor: color + '20',
            p: 1.5,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {React.cloneElement(icon, { sx: { fontSize: 32, color } })}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const EarningDashboardPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState({
    totalDrivers: 0,
    onlineDrivers: 0,
    totalPassengers: 0,
    totalRides: 0,
    activeRides: 0,
    revenueToday: 0,
    revenueMonth: 0,
    pendingVerifications: 0,
    pendingWithdrawals: 0,
    totalEarnings: 0,
    todayEarnings: 0,
    weekEarnings: 0,
    monthEarnings: 0,
    averageOrderValue: 0,
  });
  const [ridesData, setRidesData] = useState([]);
  const [revenueData, setRevenueData] = useState([]);
  const [vehicleTypeData, setVehicleTypeData] = useState([]);
  const [payments, setPayments] = useState([]);
  const [pendingPayments, setPendingPayments] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterPaymentMethod, setFilterPaymentMethod] = useState('all');

  // Format currency helper
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Generate dummy chart data for demonstration
  const generateDummyChartData = () => {
    // Generate rides data for last 7 days
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const rideData = days.map((day) => ({
      day,
      rides: Math.floor(Math.random() * 30) + 10,
      completed: Math.floor(Math.random() * 20) + 15,
      amount: Math.floor(Math.random() * 15000) + 5000,
    }));
    setRidesData(rideData);

    // Generate revenue data for last 6 months
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
    const revenueData = months.map((month) => ({
      month,
      revenue: Math.floor(Math.random() * 200000) + 50000,
      rides: Math.floor(Math.random() * 50) + 20,
    }));
    setRevenueData(revenueData);

    // Generate vehicle type distribution
    const vehicleTypes = [
      { name: 'Auto', value: 35, color: '#FFC107' },
      { name: 'Bike', value: 20, color: '#FF9800' },
      { name: 'Mini', value: 25, color: '#FF5722' },
      { name: 'Sedan', value: 15, color: '#F44336' },
      { name: 'SUV', value: 5, color: '#E91E63' },
    ];
    setVehicleTypeData(vehicleTypes);
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError('');

        // Fetch stats from backend
        const response = await apiService.getDashboardStats();

        if (response.success) {
          // Calculate additional stats
          const totalEarnings = response.data.revenueMonth || 0;
          const todayEarnings = response.data.revenueToday || 0;
          const totalRides = response.data.totalRides || 0;
          
          // Generate dummy payment data based on actual stats
          generateDummyPayments(response.data);
          
          // Generate chart data
          generateDummyChartData();

          setStats({
            totalDrivers: response.data.totalDrivers || 0,
            onlineDrivers: response.data.onlineDrivers || 0,
            totalPassengers: response.data.totalPassengers || 0,
            totalRides: totalRides,
            activeRides: response.data.activeRides || 0,
            revenueToday: todayEarnings,
            revenueMonth: totalEarnings,
            pendingVerifications: response.data.pendingVerifications || 0,
            pendingWithdrawals: response.data.pendingWithdrawals || 0,
            totalEarnings: totalEarnings,
            todayEarnings: todayEarnings,
            weekEarnings: Math.round(totalEarnings * 0.25),
            monthEarnings: totalEarnings,
            averageOrderValue: totalRides > 0 ? Math.round(totalEarnings / totalRides) : 0,
          });
        } else {
          setError(response.message || 'Failed to load dashboard data');
          // Fallback to dummy data
          generateDummyChartData();
          generateDummyPayments({});
        }
      } catch (err) {
        console.error('Dashboard error:', err);
        setError('Failed to load dashboard data. Please check if the backend server is running.');
        // Fallback to dummy data
        generateDummyChartData();
        generateDummyPayments({});
      } finally {
        setLoading(false);
      }
    };

    // Generate dummy payments based on stats
    const generateDummyPayments = (stats) => {
      const dummyPayments = [];
      const drivers = ['Rajesh Kumar', 'Suresh Reddy', 'Vikram Singh', 'Manoj Nair', 'Ravi Teja'];
      const passengers = ['John Doe', 'Priya Sharma', 'Amit Patel', 'Sneha Menon', 'Rahul Kumar'];
      const vehicleTypes = ['Sedan', 'Auto', 'Mini', 'SUV', 'Bike'];
      const paymentMethods = ['Credit Card', 'UPI', 'Debit Card', 'Google Pay', 'PhonePe'];
      
      const count = Math.max(5, Math.min(10, Math.floor((stats.totalRides || 50) / 10)));
      
      for (let i = 0; i < count; i++) {
        const date = new Date();
        date.setDate(date.getDate() - Math.floor(Math.random() * 7));
        
        dummyPayments.push({
          id: `pay_${Math.random().toString(36).substring(2, 15)}`,
          orderId: `order_${Math.random().toString(36).substring(2, 15)}`,
          amount: Math.floor(Math.random() * 500) + 100,
          currency: 'INR',
          status: ['captured', 'captured', 'captured', 'captured', 'captured', 'captured', 'captured', 'captured', 'pending', 'captured'][i % 10],
          method: ['card', 'upi', 'card', 'card', 'upi', 'card', 'card', 'upi', 'card', 'upi'][i % 10],
          email: `user${i}@example.com`,
          contact: `+919${Math.floor(Math.random() * 1000000000)}`,
          description: `Ride #R${10000 + i} - ${vehicleTypes[i % vehicleTypes.length]}`,
          createdAt: date.toISOString(),
          driverName: drivers[i % drivers.length],
          driverId: `DRV${String(i + 1).padStart(3, '0')}`,
          passengerName: passengers[i % passengers.length],
          passengerId: `PASS${String(i + 1).padStart(3, '0')}`,
          rideId: `R${10000 + i}`,
          vehicleType: vehicleTypes[i % vehicleTypes.length],
          paymentMethod: paymentMethods[i % paymentMethods.length],
          cardDetails: `${['Visa', 'Mastercard', 'Amex'][i % 3]} ending ${Math.floor(Math.random() * 10000).toString().padStart(4, '0')}`,
          refundStatus: null,
        });
      }
      
      setPayments(dummyPayments);
      
      // Generate some pending payments
      const pending = dummyPayments.filter(p => p.status === 'pending');
      setPendingPayments(pending.length > 0 ? pending : [
        {
          id: `pay_${Math.random().toString(36).substring(2, 15)}`,
          orderId: `order_${Math.random().toString(36).substring(2, 15)}`,
          amount: Math.floor(Math.random() * 500) + 100,
          currency: 'INR',
          status: 'pending',
          method: 'card',
          email: 'pending@example.com',
          contact: '+919999999999',
          description: 'Ride #R99999 - Sedan',
          createdAt: new Date().toISOString(),
          driverName: 'Pending Driver',
          driverId: 'DRV999',
          passengerName: 'Pending Passenger',
          passengerId: 'PASS999',
          rideId: 'R99999',
          vehicleType: 'Sedan',
          paymentMethod: 'Credit Card',
          cardDetails: 'Visa ending 1234',
          refundStatus: null,
        }
      ]);
    };

    // Socket listener for real-time updates
    if (socketService.onDashboardUpdate) {
      socketService.onDashboardUpdate((data) => {
        setStats((prev) => ({
          ...prev,
          ...data,
        }));
      });
    }

    loadData();

    // Refresh data every 60 seconds
    const refreshInterval = setInterval(loadData, 60000);

    return () => {
      clearInterval(refreshInterval);
      if (socketService.off) {
        socketService.off('admin:dashboard-update');
      }
    };
  }, []);

  const handlePaymentClick = (payment) => {
    setSelectedPayment(payment);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedPayment(null);
  };

  const handleApprovePayment = (paymentId) => {
    setPendingPayments(prev => prev.filter(p => p.id !== paymentId));
    const approvedPayment = pendingPayments.find(p => p.id === paymentId);
    if (approvedPayment) {
      setPayments(prev => [...prev, { ...approvedPayment, status: 'captured' }]);
      setStats(prev => ({
        ...prev,
        totalEarnings: prev.totalEarnings + approvedPayment.amount,
        totalRides: prev.totalRides + 1,
      }));
    }
  };

  const handleRejectPayment = (paymentId) => {
    setPendingPayments(prev => prev.filter(p => p.id !== paymentId));
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getStatusChip = (status) => {
    switch (status) {
      case 'captured':
        return <Chip icon={<CheckCircle />} label="Completed" color="success" size="small" />;
      case 'pending':
        return <Chip icon={<PendingActions />} label="Pending" color="warning" size="small" />;
      case 'refunded':
        return <Chip icon={<Cancel />} label="Refunded" color="error" size="small" />;
      default:
        return <Chip label={status} size="small" />;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getFilteredPayments = () => {
    let filtered = payments;
    
    if (searchTerm) {
      filtered = filtered.filter(p => 
        p.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.passengerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.driverName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.rideId?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (filterStatus !== 'all') {
      filtered = filtered.filter(p => p.status === filterStatus);
    }
    
    if (filterPaymentMethod !== 'all') {
      filtered = filtered.filter(p => p.method === filterPaymentMethod);
    }
    
    return filtered;
  };

  const getFilteredPendingPayments = () => {
    let filtered = pendingPayments;
    
    if (searchTerm) {
      filtered = filtered.filter(p => 
        p.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.passengerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.driverName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.rideId?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    return filtered;
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <CircularProgress sx={{ color: 'primary.main' }} />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Earnings Dashboard
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Real-time overview of your taxi booking platform earnings
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" startIcon={<Refresh />} onClick={() => window.location.reload()}>
            Refresh
          </Button>
          <Button variant="contained" startIcon={<Download />}>
            Export Report
          </Button>
        </Box>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Drivers"
            value={stats.totalDrivers}
            icon={<DirectionsCar />}
            color="#FFC107"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Online Drivers"
            value={stats.onlineDrivers}
            icon={<DirectionsCar />}
            color="#4CAF50"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Passengers"
            value={stats.totalPassengers}
            icon={<People />}
            color="#2196F3"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Active Rides"
            value={stats.activeRides}
            icon={<LocalTaxi />}
            color="#FF9800"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Rides"
            value={stats.totalRides}
            icon={<LocalTaxi />}
            color="#9C27B0"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Today's Revenue"
            value={`₹${stats.revenueToday.toLocaleString()}`}
            icon={<AttachMoney />}
            color="#4CAF50"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Month's Revenue"
            value={`₹${stats.revenueMonth.toLocaleString()}`}
            icon={<AttachMoney />}
            color="#00BCD4"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Pending Verifications"
            value={stats.pendingVerifications}
            icon={<Pending />}
            color="#F44336"
          />
        </Grid>
      </Grid>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Earnings"
            value={formatCurrency(stats.totalEarnings)}
            icon={<AttachMoney />}
            color="#4CAF50"
            trend="up"
            trendValue="12.5%"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Today's Earnings"
            value={formatCurrency(stats.todayEarnings)}
            icon={<Payment />}
            color="#FFC107"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="This Week"
            value={formatCurrency(stats.weekEarnings)}
            icon={<TrendingUp />}
            color="#2196F3"
            trend="up"
            trendValue="8.3%"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="This Month"
            value={formatCurrency(stats.monthEarnings)}
            icon={<TrendingUp />}
            color="#9C27B0"
            trend="up"
            trendValue="15.7%"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Rides"
            value={stats.totalRides}
            icon={<LocalTaxi />}
            color="#FF9800"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Average Order Value"
            value={formatCurrency(stats.averageOrderValue)}
            icon={<Receipt />}
            color="#00BCD4"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Pending Payments"
            value={pendingPayments.length}
            icon={<Pending />}
            color="#F44336"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Drivers"
            value={stats.totalDrivers}
            icon={<DirectionsCar />}
            color="#FF5722"
          />
        </Grid>
      </Grid>

      {/* Charts */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {/* Rides Chart */}
        <Grid item xs={12} lg={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Rides & Earnings Overview (Last 7 Days)
              </Typography>
              {ridesData.length > 0 ? (
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={ridesData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" />
                    <YAxis yAxisId="left" />
                    <YAxis yAxisId="right" orientation="right" />
                    <RechartsTooltip />
                    <Legend />
                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="rides"
                      stroke="#FFC107"
                      strokeWidth={2}
                      name="Total Rides"
                    />
                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="completed"
                      stroke="#4CAF50"
                      strokeWidth={2}
                      name="Completed"
                    />
                    <Line
                      yAxisId="right"
                      type="monotone"
                      dataKey="amount"
                      stroke="#2196F3"
                      strokeWidth={2}
                      name="Earnings (₹)"
                    />
                  </LineChart>
                </ResponsiveContainer>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                  <Typography color="text.secondary">No ride data available</Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Vehicle Type Distribution */}
        <Grid item xs={12} lg={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Vehicle Type Distribution
              </Typography>
              {vehicleTypeData.some(v => v.value > 0) ? (
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={vehicleTypeData}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={(entry) => `${entry.name}: ${entry.value}%`}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {vehicleTypeData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <RechartsTooltip />
                  </PieChart>
                </ResponsiveContainer>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                  <Typography color="text.secondary">No vehicle data available</Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Revenue Chart */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Revenue & Rides Overview (Last 6 Months)
              </Typography>
              {revenueData.some(r => r.revenue > 0) ? (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={revenueData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis yAxisId="left" />
                    <YAxis yAxisId="right" orientation="right" />
                    <RechartsTooltip />
                    <Legend />
                    <Bar yAxisId="left" dataKey="revenue" fill="#FFC107" name="Revenue (₹)" />
                    <Bar yAxisId="right" dataKey="rides" fill="#4CAF50" name="Total Rides" />
                  </BarChart>
                </ResponsiveContainer>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                  <Typography color="text.secondary">No revenue data available</Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Payment Transactions */}
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
            <Typography variant="h6" fontWeight="bold">
              Payment Transactions
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <TextField
                size="small"
                placeholder="Search payments..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
              />
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  label="Status"
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="captured">Completed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="refunded">Refunded</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Method</InputLabel>
                <Select
                  value={filterPaymentMethod}
                  onChange={(e) => setFilterPaymentMethod(e.target.value)}
                  label="Method"
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="card">Card</MenuItem>
                  <MenuItem value="upi">UPI</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab label={`All Payments (${getFilteredPayments().length})`} />
            <Tab label={`Pending (${getFilteredPendingPayments().length})`} />
          </Tabs>

          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Payment ID</TableCell>
                  <TableCell>Date & Time</TableCell>
                  <TableCell>Passenger</TableCell>
                  <TableCell>Driver</TableCell>
                  <TableCell>Ride ID</TableCell>
                  <TableCell>Vehicle</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Method</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tabValue === 0 ? (
                  getFilteredPayments().map((payment) => (
                    <TableRow key={payment.id} hover>
                      <TableCell>
                        <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }}>
                          {payment.id.slice(0, 12)}...
                        </Typography>
                      </TableCell>
                      <TableCell>{formatDate(payment.createdAt)}</TableCell>
                      <TableCell>{payment.passengerName}</TableCell>
                      <TableCell>{payment.driverName}</TableCell>
                      <TableCell>{payment.rideId || '—'}</TableCell>
                      <TableCell>
                        <Chip label={payment.vehicleType} size="small" variant="outlined" />
                      </TableCell>
                      <TableCell>
                        <Typography fontWeight="bold" color="success.main">
                          {formatCurrency(payment.amount)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={payment.method.toUpperCase()} 
                          size="small" 
                          color={payment.method === 'card' ? 'primary' : 'secondary'}
                        />
                      </TableCell>
                      <TableCell>{getStatusChip(payment.status)}</TableCell>
                      <TableCell>
                        <Tooltip title="View Details">
                          <IconButton size="small" onClick={() => handlePaymentClick(payment)}>
                            <Visibility />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  getFilteredPendingPayments().map((payment) => (
                    <TableRow key={payment.id} hover sx={{ bgcolor: 'warning.light' }}>
                      <TableCell>
                        <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }}>
                          {payment.id.slice(0, 12)}...
                        </Typography>
                      </TableCell>
                      <TableCell>{formatDate(payment.createdAt)}</TableCell>
                      <TableCell>{payment.passengerName}</TableCell>
                      <TableCell>{payment.driverName}</TableCell>
                      <TableCell>{payment.rideId || '—'}</TableCell>
                      <TableCell>
                        <Chip label={payment.vehicleType} size="small" variant="outlined" />
                      </TableCell>
                      <TableCell>
                        <Typography fontWeight="bold" color="warning.main">
                          {formatCurrency(payment.amount)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={payment.method.toUpperCase()} 
                          size="small" 
                          color={payment.method === 'card' ? 'primary' : 'secondary'}
                        />
                      </TableCell>
                      <TableCell>{getStatusChip('pending')}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          <Tooltip title="Approve Payment">
                            <IconButton 
                              size="small" 
                              color="success"
                              onClick={() => handleApprovePayment(payment.id)}
                            >
                              <CheckCircle />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Reject Payment">
                            <IconButton 
                              size="small" 
                              color="error"
                              onClick={() => handleRejectPayment(payment.id)}
                            >
                              <Cancel />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="View Details">
                            <IconButton size="small" onClick={() => handlePaymentClick(payment)}>
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
                {tabValue === 0 && getFilteredPayments().length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography color="text.secondary" sx={{ py: 3 }}>
                        No payments found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
                {tabValue === 1 && getFilteredPendingPayments().length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography color="text.secondary" sx={{ py: 3 }}>
                        No pending payments
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Payment Details Dialog */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        {selectedPayment && (
          <>
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Payment Details</Typography>
                {getStatusChip(selectedPayment.status)}
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Payment ID</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>{selectedPayment.id}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Order ID</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>{selectedPayment.orderId}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Amount</Typography>
                  <Typography variant="h5" color="success.main" fontWeight="bold">
                    {formatCurrency(selectedPayment.amount)}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Payment Method</Typography>
                  <Typography variant="body1">{selectedPayment.paymentMethod}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {selectedPayment.cardDetails}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Date & Time</Typography>
                  <Typography variant="body1">{formatDate(selectedPayment.createdAt)}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Status</Typography>
                  <Typography variant="body1">{selectedPayment.status}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="subtitle1" fontWeight="bold">Ride Details</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">Ride ID</Typography>
                  <Typography variant="body1">{selectedPayment.rideId || '—'}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">Vehicle Type</Typography>
                  <Typography variant="body1">{selectedPayment.vehicleType}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">Description</Typography>
                  <Typography variant="body1">{selectedPayment.description}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" fontWeight="bold">Customer Details</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">Passenger</Typography>
                  <Typography variant="body1">{selectedPayment.passengerName}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">Email</Typography>
                  <Typography variant="body1">{selectedPayment.email}</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">Contact</Typography>
                  <Typography variant="body1">{selectedPayment.contact}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" fontWeight="bold">Driver Details</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Driver Name</Typography>
                  <Typography variant="body1">{selectedPayment.driverName}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="text.secondary">Driver ID</Typography>
                  <Typography variant="body1">{selectedPayment.driverId}</Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>Close</Button>
              {selectedPayment.status === 'pending' && (
                <>
                  <Button 
                    variant="contained" 
                    color="success"
                    onClick={() => {
                      handleApprovePayment(selectedPayment.id);
                      handleCloseDialog();
                    }}
                  >
                    Approve Payment
                  </Button>
                  <Button 
                    variant="contained" 
                    color="error"
                    onClick={() => {
                      handleRejectPayment(selectedPayment.id);
                      handleCloseDialog();
                    }}
                  >
                    Reject Payment
                  </Button>
                </>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default EarningDashboardPage;